import { Controller } from "@hotwired/stimulus"

// Drives the reveal on the express "You've already started" auto-fill interstitial when the LLM
// auto-fill finishes. Listens for the window-level autofill:complete event (fired by autofill-signal
// once the fill is done, whether via poll or broadcast): rolls the entry-count + minutes-saved numbers
// up (jackpot-number), swaps the read-only cards for the fully-filled set while animating the
// newly-added rows, and enables the Continue button. Idempotent — reveals only once — and stops the
// status poll afterwards. Also handles the footer Back / Continue clicks.
export default class extends Controller {
  static targets = ["count", "minutes", "countWord", "minuteWord", "cards", "continue"]
  static values = { frameId: String }

  reveal(event) {
    if (this.revealed) return
    this.revealed = true

    this.stopPolling()

    const detail = event.detail || {}
    this.rollNumber(this.hasCountTarget ? this.countTarget : null, detail.count)
    this.rollNumber(this.hasMinutesTarget ? this.minutesTarget : null, detail.minutes)
    this.setWord(this.hasCountWordTarget ? this.countWordTarget : null, detail.countWord)
    this.setWord(this.hasMinuteWordTarget ? this.minuteWordTarget : null, detail.minuteWord)
    this.swapCards(detail.cardsHtml)
    this.enableContinue()
  }

  continue() {
    const url = this.hasContinueTarget && this.continueTarget.dataset.continueUrl
    if (url) Turbo.visit(url)
  }

  back() {
    history.back()
  }

  // Remove the polled frame's src + poll controller so it stops re-fetching once we've revealed.
  stopPolling() {
    const frame = this.frameIdValue && document.getElementById(this.frameIdValue)
    if (!frame) return
    frame.removeAttribute("src")
    frame.removeAttribute("data-controller")
  }

  rollNumber(element, value) {
    if (!element || value === undefined || value === null) return
    const jackpot = this.application.getControllerForElementAndIdentifier(element, "jackpot-number")
    if (jackpot) jackpot.setValue(String(value))
    else element.textContent = String(value)
  }

  setWord(element, word) {
    if (element && word) element.textContent = word
  }

  swapCards(html) {
    if (!this.hasCardsTarget || !html) return
    const seen = new Set(
      Array.from(this.cardsTarget.querySelectorAll("[data-entry-key]")).map((el) => el.dataset.entryKey)
    )
    this.cardsTarget.innerHTML = html
    this.cardsTarget.querySelectorAll("[data-entry-key]").forEach((el) => {
      if (!seen.has(el.dataset.entryKey)) el.classList.add("cc-entry-enter")
    })
  }

  enableContinue() {
    if (!this.hasContinueTarget) return
    this.continueTarget.disabled = false
    this.continueTarget.classList.remove("opacity-50", "cursor-not-allowed")
  }
}
